module.exports = __webpack_public_path__ + "static/media/bbwexe_background.34a83667.mp3";